/* eslint-disable react/destructuring-assignment */
import React, { useContext, useEffect } from 'react';
import { Card, CardContent, Typography, Modal, Grid, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import modalIcon from '../../images/upload_modal_icon.svg';
import { CommonModalStyles as classes } from './CommonModalStyle';

const CommonModal = (props) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);

  const { setChecklistErrGlobal, setUploadGlobalStatus, setStatementUploadStatus } =
    leadGenerationContext;
  const [open, setOpen] = React.useState(true);
  let valtype;
  if (props.message.typeName) {
    valtype = props.message.typeName;
  }
  const handleClose = () => {
    props.setIsModal(false);
    setOpen(false);
    if (valtype === 'businessAddress') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, businessAddress: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({
        ...prevState,
        businessAddress: '',
      }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({
        ...prevState,
        businessAddress: '',
      }));
      leadGenerationContext.setGlobalProgress((prevState) => ({
        ...prevState,
        businessAddress: 0,
      }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({
        ...disb,
        businessAddress: false,
      }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({
        ...prevState,
        businessAddress: '',
      }));
    }
    if (valtype === 'businessOwnerAddress') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, businessOwnerAddress: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({
        ...prevState,
        businessOwnerAddress: '',
      }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({
        ...prevState,
        businessOwnerAddress: '',
      }));
      leadGenerationContext.setGlobalProgress((prevState) => ({
        ...prevState,
        businessOwnerAddress: 0,
      }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({
        ...disb,
        businessOwnerAddress: false,
      }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({
        ...prevState,
        businessOwnerAddress: '',
      }));
    }
    if (valtype === 'act') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, act: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({ ...prevState, act: '' }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({ ...prevState, act: '' }));
      leadGenerationContext.setGlobalProgress((prevState) => ({ ...prevState, act: 0 }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({ ...disb, act: false }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({ ...prevState, act: '' }));
    }
    if (valtype === 'atm') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, atm: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({ ...prevState, atm: '' }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({ ...prevState, atm: '' }));
      leadGenerationContext.setGlobalProgress((prevState) => ({ ...prevState, atm: 0 }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({ ...disb, atm: false }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({ ...prevState, atm: '' }));
    }
    if (valtype === 'statementUpload') {
      setStatementUploadStatus(null);
      setChecklistErrGlobal((prevState) => ({ ...prevState, statementUpload: '' }));
    }
    if (valtype === 'act22') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, act22: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({ ...prevState, act22: '' }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({ ...prevState, act22: '' }));
      leadGenerationContext.setGlobalProgress((prevState) => ({ ...prevState, act22: 0 }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({ ...disb, act22: false }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({ ...prevState, act22: '' }));
    }
    if (valtype === 'emancipationevidence') {
      setUploadGlobalStatus((prevState) => ({ ...prevState, emancipationevidence: '' }));
      leadGenerationContext.setUploadGlobalFiles((prevState) => ({
        ...prevState,
        emancipationevidence: '',
      }));
      leadGenerationContext.setUploadGlobalDocId((prevState) => ({
        ...prevState,
        emancipationevidence: '',
      }));
      leadGenerationContext.setGlobalProgress((prevState) => ({
        ...prevState,
        emancipationevidence: 0,
      }));
      leadGenerationContext.setIsGlobalFileUploadingAll((disb) => ({
        ...disb,
        emancipationevidence: false,
      }));
      leadGenerationContext.setChecklistErrGlobal((prevState) => ({
        ...prevState,
        emancipationevidence: '',
      }));
    }
  };
  const handleCloseTry = () => {
    props.setIsModal(false);
    setOpen(false);
  };

  useEffect(() => {
    props.openModal ? setOpen(true) : setOpen(false);
  }, [props.openModal]);

  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1BusinessDesc dialog2BusinessDesc"
    >
      <div style={{ outline: 'none' }}>
        <Card sx={classes.root}>
          <CardContent sx={classes.card_content}>
            <div style={{ marginBottom: '24px', marginTop: '33px' }}>
              <img src={modalIcon} alt="modal icon" height="43px" width="48px" />
            </div>
            <div style={{ paddingLeft: '25px', paddingRight: '25px' }}>
              <Typography sx={classes.textOneStyle} id="dialog1BusinessDesc">
                {t(props.message.messageTitle, {
                  defaultValue: props.message.messageTitle,
                  nsSeparator: '|',
                })}
              </Typography>
              <Typography sx={classes.textOneStyle} id="dialog2BusinessDesc">
                {t(props.message.messageSubTitle, {
                  defaultValue: props.message.messageSubTitle,
                  nsSeparator: '|',
                })}
              </Typography>
            </div>
            <Grid container sx={classes.btnAlign}>
              <Grid
                size={{ xs: 12 }}
                style={{
                  marginTop: '13px',
                  marginBottom: '27px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Button
                  disableFocusRipple
                  autoFocus
                  sx={classes.back_button}
                  data-testid="CloseButtonInBusinessModal"
                  onClick={handleClose}
                  aria-label={t('Close', { defaultValue: 'Close' })}
                >
                  {t('Close', { defaultValue: 'Close' })}
                </Button>
                <Button
                  disableFocusRipple
                  autoFocus
                  variant="outlined"
                  sx={classes.saveAndExit_Close}
                  data-testid="CloseTryButtonInBusinessModal"
                  onClick={handleCloseTry}
                >
                  {t('Try Again', { defaultValue: 'Try Again' })}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </Modal>
  );
};
export default withRouter(CommonModal);

CommonModal.propTypes = {
  setIsModal: PropTypes.func,
  openModal: PropTypes.func,
  message: PropTypes.object,
};
